/* Seznam doporučených produktů pod CTA (blok recommended_list).
   Každý řádek se chová jako quick-add na produktové kartě: „+" přidá kus
   přes Cart API (během požadavku běží spinner), atribut [in-cart] na řádku
   přepne „+" na stepper s počtem kusů. /cart/update.js umí položku do košíku
   i přidat, takže plus, mínus i první přidání jdou jedním endpointem.
   Stav se synchronizuje přes pub/sub cartUpdate. */

if (!customElements.get('product-reco-list')) {
  customElements.define(
    'product-reco-list',
    class ProductRecoList extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-reco-list' && event.element === this) return;
          this.syncFromCart(event.cartData);
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onClick(event) {
        const row = event.target.closest('[data-reco-cart]');
        if (!row || row.hasAttribute('aria-busy')) return;
        if (event.target.closest('[data-reco-add], [data-stepper-plus]')) {
          this.change(row, 1);
        } else if (event.target.closest('[data-stepper-minus]')) {
          this.change(row, -1);
        }
      }

      quantity(row) {
        return parseInt(row.querySelector('[data-stepper-qty]').textContent, 10) || 0;
      }

      setQuantity(row, quantity) {
        row.querySelector('[data-stepper-qty]').textContent = quantity;
        row.toggleAttribute('in-cart', quantity > 0);
      }

      async syncFromCart(cartData) {
        try {
          // Odpověď /cart/add.js (cizí zdroje) nenese celý košík — došteme si ho
          let items = cartData && cartData.items;
          if (!items) {
            const response = await fetch(`${routes.cart_url}.js`);
            items = (await response.json()).items;
          }
          this.querySelectorAll('[data-reco-cart]').forEach((row) => {
            const variantId = Number(row.dataset.variantId);
            const quantity = items
              .filter((item) => item.variant_id === variantId)
              .reduce((sum, item) => sum + item.quantity, 0);
            this.setQuantity(row, quantity);
          });
        } catch {
          /* síťová chyba — ponecháme poslední známý stav */
        }
      }

      async change(row, delta) {
        const variantId = Number(row.dataset.variantId);
        const newQuantity = Math.max(0, this.quantity(row) + delta);
        row.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(routes.cart_update_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [variantId]: newQuantity }, sections: 'cart-icon-bubble' }),
          });
          const cart = await response.json();
          if (cart.status) throw new Error(cart.message);

          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && cart.sections && cart.sections['cart-icon-bubble']) {
            const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
            bubble.innerHTML = parsed.querySelector('.shopify-section').innerHTML;
          }

          // Skutečné množství z odpovědi (sklad může požadavek snížit)
          this.syncFromCart(cart);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-reco-list',
            element: this,
            cartData: cart,
            variantId: variantId,
          });
        } catch (error) {
          console.error(error);
        } finally {
          row.removeAttribute('aria-busy');
        }
      }
    }
  );
}
